module.exports = __webpack_public_path__ + "img/illu-icon-80-talk-plus.e73d979a.svg";